import { render, staticRenderFns } from "./OdinHandoff.vue?vue&type=template&id=6de3d7dc&"
import script from "./OdinHandoff.vue?vue&type=script&lang=js&"
export * from "./OdinHandoff.vue?vue&type=script&lang=js&"
import style0 from "./OdinHandoff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports